import "@/App.css";
import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";
import { Toaster } from "sonner";
import BlogHome from "@/pages/BlogHome";
import ContentDetail from "@/pages/ContentDetail";
import Admin from "@/pages/Admin";
import Preview from "@/pages/Preview";

function HomeGate() {
  const [params] = useSearchParams();
  const adminKey = params.get("admin");
  if (adminKey) return <Admin adminKey={adminKey} />;
  return <BlogHome />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeGate />} />
          <Route path="/content/:id" element={<ContentDetail />} />
          <Route path="/preview/:id" element={<Preview />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}

export default App;
